import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Params } from '@angular/router';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class IconButtonComponent {
  @Input({ required: true }) icon: string;
  @Input({ required: true }) ariaLabel: string;
  @Input() tooltip: string;
  @Input() link: string | any[] | null = null;
  @Input() queryParams: Params | null = null;
  @Input() disabled = false;
  @Input() loading = false;
  @Input() confirmTitle: string;
  @Output() pressed = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();

  get hint(): string {
    return this.tooltip || this.ariaLabel;
  }
}
